import { createSelector } from '@ngrx/store';
import { getOnboardingPageState } from '../onboarding.selectors';

// ------------------ REGISTRATION ---------------
export const getRegistrationState = createSelector(
  getOnboardingPageState,
  (state) => state.registrationState
);

//// --> REGISTRATION: USER
export const getRegistrationUserState = createSelector(
  getRegistrationState,
  (registrationState) => registrationState
);

export const getRegistrationUserIsLoading = createSelector(
  getRegistrationUserState,
  (user) => user.isLoading
);
export const getRegistrationUserData = createSelector(
  getRegistrationUserState,
  (user) => user.data
);
export const getRegistrationUserSuccess = createSelector(
  getRegistrationUserState,
  (user) => user.success
);
export const getRegistrationUserError = createSelector(
  getRegistrationUserState,
  (user) => user.error
);
